export const Logo = ({ className = "h-7 w-auto", light = false }) => (
  <img
    src={light ? "/ic-identity-logo-light.webp" : "/ic-identity-logo.webp"}
    alt="IC Identity"
    className={className}
    width="131"
    height="40"
    decoding="async"
  />
);
